"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_list_plan_steps',
    description: 'List the steps of a plan with their stable id, status, files, description, in-plan blockers, and req citations. Pure read. Used by clients to compute which steps are doable, which are blocked, and to render multi-step pickers. `blockedBy` entries reference step `id`s (or plan ids).',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id. Canonical form is the ULID (e.g. "pl_01J…"); the filename stem (e.g. "my-weave-plan-001") is also accepted and resolved.' },
        },
        required: ['planId'],
    },
};
async function handle(root, args) {
    const planId = args['planId'];
    // Primary (agent-supplied) id → suggest-on-miss.
    const { filePath: planFilePath } = await (0, dist_1.resolveDocIdOrThrow)(root, planId);
    const planDoc = await (0, dist_1.loadDoc)(planFilePath);
    if (planDoc.type !== 'plan')
        throw new Error(`Document ${planId} is not a plan`);
    const steps = (planDoc.steps ?? []).map(s => ({
        id: s.id,
        order: s.order,
        description: s.description,
        filesToTouch: s.files_touched,
        done: s.status === 'done',
        status: s.status,
        blockedBy: s.blockedBy ?? [],
        // The req-citation contract: the IN/C ids this step advances. Surfaced so
        // pickers can render coverage where steps are shown (not just in Verify).
        satisfies: s.satisfies ?? [],
    }));
    const result = {
        planId,
        planTitle: planDoc.title,
        planStatus: planDoc.status,
        steps,
    };
    return {
        content: [{
                type: 'text',
                text: JSON.stringify(result, null, 2),
            }],
    };
}
